// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
} from '@mui/material';
// hooks
import useResponsive from "../../../hooks/useResponsive";
// components
import DIOText from "../../../components/DIOText";
import Iconify from "../../../components/Iconify";

// ------------------------------------------------------------------------------

export default function SpeedMatchingDialog({ isOpen, closeDialog }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} fullWidth maxWidth="dg">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={'eva:alert-circle-fill'} sx={{ height: 24, width: 24, color: "info.main" }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} sx={{ wordBreak: "keep-all" }} paragraph>
          [스피드 매칭] 어떤 방식으로 진행되나요?
        </Typography>
        <Typography variant={smUp ? "body1": "body2"} sx={{ wordBreak: "keep-all" }}>
          스피드 매칭을 희망하시는 경우, <DIOText />의 심사를 통과한 크루 전체를 대상으로 공고가 공개됩니다.
        </Typography>
        <Typography variant={smUp ? "body1": "body2"} sx={{ wordBreak: "keep-all" }} paragraph>
          목록 게시판 형태로 공고가 공개되어 <b>평균 2~3배 더 빠르게 지원자를 받아보실 수 있습니다.</b>
        </Typography>
        <Typography variant={smUp ? "body1": "body2"} sx={{ wordBreak: "keep-all" }}>
          스피드 매칭을 선택하지 않을 경우,
        </Typography>
        <Typography variant={smUp ? "body1": "body2"} sx={{ wordBreak: "keep-all" }}>
          <DIOText />가 선택한 크루만 일정에 맞게 매칭이 됩니다. 다른 크루는 공고의 게시 여부를 알 수 없습니다.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Button
          variant="contained"
          onClick={closeDialog}
          fullWidth={!smUp}
          size="large"
          sx={{ px: 5 }}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}
